import {
  HubSection,
  HubSectionType,
  HubSectionUpsertParams,
  HubSplitSectionContentType,
  HubUpsertParams,
} from 'utils/gloo-types';

export type ClientHubSection = HubSection & { clientId: string };
export type ClientHubSectionUpsertParams = HubSectionUpsertParams & { clientId: string };
export type ClientHubUpsertParams = Omit<HubUpsertParams, 'sections'> & { sections: ClientHubSectionUpsertParams[] };

export enum SectionPrefix {
  FullWidth = 'FullWidth',
  FiftyFifty = 'FiftyFifty',
}

export type StartPageState = SectionPrefix | HubSectionType.RESOURCE;
export type FullWidthSection =
  | {
      type: HubSectionType.IMAGE;
    }
  | {
      type: HubSectionType.TEXT;
    }
  | {
      type: HubSectionType.RESOURCE;
    };

export type SplitWidthSection = {
  type: HubSectionType.SPLIT;
  a: HubSplitSectionContentType;
  b: HubSplitSectionContentType;
};

export type SectionContentType = FullWidthSection | SplitWidthSection;

export enum HubAuthoringSelectSectionModalPages {
  StartPage = 'StartPage',
  FullWidthPage = 'FullWidthPage',
  SplitWidthPage = 'SplitWidthPage',
}

// States for TabBar
export enum HubAuthoringTabLabel {
  Edit = 'Edit',
  Preview = 'Preview',
}

export enum HubAuthoringFormProperty {
  title = 'title',
  author = 'author',
  logoImageUrl = 'logoImageUrl',
  headerImageUrl = 'headerImageUrl',
  thumbnailImageUrl = 'thumbnailImageUrl',
  sections = 'sections',
}

export enum HubAuthoringSectionProperty {
  imageUrl = 'imageUrl',
}

export type HubAuthoringSectionErrors = Record<
  string,
  {
    a?: { [HubAuthoringSectionProperty.imageUrl]?: string };
    b?: { [HubAuthoringSectionProperty.imageUrl]?: string };
  } & { [HubAuthoringSectionProperty.imageUrl]?: string }
>;

export type HubAuthoringFormErrors = {
  [HubAuthoringFormProperty.title]?: string;
  [HubAuthoringFormProperty.author]?: string;
  [HubAuthoringFormProperty.logoImageUrl]?: string;
  [HubAuthoringFormProperty.headerImageUrl]?: string;
  [HubAuthoringFormProperty.thumbnailImageUrl]?: string;
  [HubAuthoringFormProperty.sections]: HubAuthoringSectionErrors;
};
